import { render, staticRenderFns } from "./GoodGrid.vue?vue&type=template&id=19556f33&scoped=true&"
import script from "./GoodGrid.vue?vue&type=script&lang=js&"
export * from "./GoodGrid.vue?vue&type=script&lang=js&"
import style0 from "./GoodGrid.vue?vue&type=style&index=0&id=19556f33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19556f33",
  null
  
)

export default component.exports